import React from 'react';
import { AddTaxIdButton } from '../BillingDetailsSection';
import { TaxIdDto } from '../../dto';

export const TaxIdRequiredBanner = (props: { taxId: TaxIdDto }) => {
  const { taxId } = props;
  return (
    <div className="billing__ein-is-required-banner" data-test="billing__ein-required-banner">
      Regular credit reporting will not start until you provide your Company Tax ID or EIN.
      <AddTaxIdButton
        taxIdStatus={taxId.status}
        dateTest="billing__ein-required-banner-button"
        text="Add EIN now"
      />
    </div>
  );
};
